import React, { useEffect, useState } from "react";
import { getDatabase, ref, get } from "firebase/database";
import { Link } from "react-router-dom";
import { toast } from "../toast";

const ArticleSearch = () => {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchArticles = async () => {
      try {
        const db = getDatabase();
        const snapshot = await get(ref(db, "NEWS/"));

        if (snapshot.exists()) {
          const newsData = snapshot.val();
          
          // Convert to array and filter for public articles
          const articleList = Object.entries(newsData)
            .map(([id, data]) => ({
              id,
              ...data,
            }))
            .filter((article) => article.NEWS_ARTICLEPUBLIC !== "N");

          // Sort by date (latest first)
          // Date format is DD/MM/YYYY
          const parseDate = (dateStr) => {
            if (!dateStr) return new Date(0);
            const [day, month, year] = dateStr.split('/');
            return new Date(year, month - 1, day);
          };
          
          articleList.sort((a, b) => {
            const dateA = parseDate(a.NEWS_ARTICLEDATE);
            const dateB = parseDate(b.NEWS_ARTICLEDATE);
            return dateB - dateA;
          });

          setArticles(articleList);
        } else {
          setArticles([]);
        }
      } catch (error) {
        // console.error("Error fetching articles:", error);
        toast("Error loading articles", "#", "danger");
      } finally {
        setLoading(false);
      }
    };

    fetchArticles();
  }, []);

  if (loading) {
    return (
      <div className="text-center py-5">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  if (articles.length === 0) {
    return (
      <div className="text-center py-5">
        <p className="text-muted">No articles available yet.</p>
      </div>
    );
  }

  return (
    <div className="articles-list">
      {articles.map((article) => (
        <Link
          key={article.id}
          to={`/news/${article.NEWS_ARTICLESLUG}`}
          className="article-card-link"
        >
          <div className="article-card mb-4">
            <div className="article-card-header">
              <h3 className="article-card-title">{article.NEWS_ARTICLETITLE}</h3>
              <div className="article-card-meta">
                <span className="article-date">{article.NEWS_ARTICLEDATE}</span>
                {article.SETCATEGORY && (
                  <span className="event-badges ms-2">{article.SETCATEGORY}</span>
                )}
              </div>
            </div>

            <div className="article-card-body">
              {article.NEWS_ARTICLESHORTDESC && (
                <p className="article-short-desc">{article.NEWS_ARTICLESHORTDESC}</p>
              )}
            </div>

            <div className="article-card-footer">
              <span className="read-more">Read More →</span>
            </div>
          </div>
        </Link>
      ))}
    </div>
  );
};

export default ArticleSearch;
